import './navbar.css';
import '../../App.css';
import * as React from 'react'
import {Component} from "react";
import {NavbarDropdownLink, NavbarLink} from "../../widgets";
import {setActiveMenuItem, setLogoWhite, setNavbarTheme} from "../../util";

export class Navbar extends Component {

    static TOGGLE_CLASS = 'navbar-dropdown-menu-hidden';
    static TOGGLE_ICON_CLASS = 'bars';
    static CLOSE_ICON_CLASS = 'times';

    constructor(props) {
        super(props);
        this.state = {
            isPhone: window.innerWidth < 1000,
            isHidden: true
        }
        this.toggleClass = Navbar.TOGGLE_CLASS;
        this.toggleIconClass = Navbar.TOGGLE_ICON_CLASS;
    }

    componentDidMount() {

        const self = this;

        window.matchMedia('(min-width: 1000px').addEventListener('change', () => {
                    self.setState({isPhone: window.innerWidth < 1000});
                    self.setActive();
                    self.hideDropdown(true);
                });
    }

    setActive() {
        let url = window.location.href;

        if(url.includes('om_oss')) {
            setNavbarTheme('#040f2b');
            setActiveMenuItem('om_oss', window.innerWidth < 1000);
            setLogoWhite(false)
        } else if (url.includes('prosess')) {
            setNavbarTheme('#040f2b');
            setActiveMenuItem('prosess', window.innerWidth < 1000);
            setLogoWhite(false)
        } else if (url.includes('team')) {
            setNavbarTheme('#040f2b');
            setActiveMenuItem('team', window.innerWidth < 1000);
            setLogoWhite(false)
        } else if (url.includes('kontakt_oss')) {
            setNavbarTheme('#040f2b');
            setActiveMenuItem('kontakt_oss', window.innerWidth < 1000);
            setLogoWhite(false)
        } else {
            setNavbarTheme('#FFFFFF');
            setActiveMenuItem('', window.innerWidth < 1000);
            setLogoWhite(true)
        }
    }

    hideDropdown(value) {
        if(value) {
            this.toggleClass = Navbar.TOGGLE_CLASS;
            this.toggleIconClass = Navbar.TOGGLE_ICON_CLASS;
        } else {
            this.toggleClass = '';
            this.toggleIconClass = Navbar.CLOSE_ICON_CLASS;
        }
        this.setState({isHidden: value})
    }

    render () {
        return (
            <div className={'default-cage'}>
                {this.renderNavbar()}
            </div>
        )
    }

    renderNavbar() {
        if(this.state.isPhone) {
            return (
                <div className={'navbar-dropdown'}>
                    <div className={'navbar-dropdown-top'}>
                        <div className={'navbar-logo'}>
                            <a href={'/#/'} style={{ textDecoration: 'none' }} onClick={() => this.hideDropdown(true)}>
                                <img alt={'hjem'} className={'navbar-logo-image navbar-logo-image-dropdown'} src={'resources/blonomLogo.png'}/>
                            </a>
                        </div>
                        <div className={'default-center navbar-dropdown-toggle'}>
                            <button onClick={() => this.hideDropdown(!this.state.isHidden)}>
                                <i className={'fa fa-' + this.toggleIconClass}/>
                            </button>
                        </div>
                    </div>
                    <div className={'navbar-dropdown-menu ' + this.toggleClass}>
                        <NavbarDropdownLink name={'Om oss'} url={'om_oss'} callBack={() => this.hideDropdown(true)}/>
                        <NavbarDropdownLink name={'Prosess'} url={'prosess'} callBack={() => this.hideDropdown(true)}/>
                        <NavbarDropdownLink name={'Teamet'} url={'team'} callBack={() => this.hideDropdown(true)}/>
                        <NavbarDropdownLink name={'Kontakt oss'} url={'kontakt_oss'} callBack={() => this.hideDropdown(true)}/>
                    </div>
                </div>
            )
        } else {
            return (
                <div className={'default-cage'}>
                    <div className={'navbar'}>
                        <div className={'default-center'}>
                            <div className={'navbar-logo'}>
                                <a href={'/#/'} style={{ textDecoration: 'none' }} onClick={() => this.hideDropdown(true)}>
                                    <img alt={'hjem'} className={'navbar-logo-image'} src={'resources/blonomLogo.png'}/>
                                </a>
                            </div>
                        </div>
                        <NavbarLink name={'Om oss'} url={'om_oss'}/>
                        <NavbarLink name={'Prosess'} url={'prosess'}/>
                        <NavbarLink name={'Teamet'} url={'team'}/>
                        <NavbarLink name={'Kontakt oss'} url={'kontakt_oss'}/>
                    </div>
                </div>
            )
        }
    }
}